import { storyblokRoutesPaths } from "@/routes/storyblok"
import { useStoryblokBreadcrumb } from "../../../../hooks/useStoryblokBreadcrumb"
import { type SbFaqArticleB2bgStory } from "../../../../types"
import { StoryblokFAQArticle } from "../../../FAQArticle"

type FaqArticleB2bgTemplateProps = {
    story: SbFaqArticleB2bgStory
}

export function FaqArticleB2bgTemplate({ story }: FaqArticleB2bgTemplateProps) {
    const { title, blocks } = story.content

    // TODO is loading behavior
    const crumbs = useStoryblokBreadcrumb({
        story,
        root: {
            href: storyblokRoutesPaths.faqBusiness.resolve(),
            title: "FAQ entreprises et collectivités",
        },
    })

    return (
        <StoryblokFAQArticle
            crumbs={crumbs}
            title={title}
            blocks={blocks}
        />
    )
}
